.report-card--with-illustration {
    grid-column: span 2;
    grid-row: span 2;
}

.report-card--with-illustration-right {
    grid-column: 2 / span 2;
    grid-row: span 2;
}

.grid-right-illustration {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: dense;
    gap: 16px;
}

.default-reports-container {
    gap: 12px;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.sections-container {
    display: flex;
    flex-direction: column;
    gap: 64px;
}
